/* eslint-disable max-len */
/* eslint-disable no-console */
import React from 'react';
import { Panel, useReactFlow, getRectOfNodes } from 'reactflow';
import { toPng } from 'html-to-image';

function DownloadFlowsheet(props) {
  const { flowsheetImage } = props;
  const { getNodes } = useReactFlow();
  const onTheFlyStyle = (toTag = 'input', withTag = 'img', flag = true) => {
    document.querySelectorAll('.nodeimg').forEach((ele) => {
      const imgEle = document.createElement(withTag);
      if (ele.querySelector(toTag)) {
        const closeTag = ele.closest('.custom-node-element').querySelector('.unitop-close-icon-div');
        if (closeTag) {
          if (flag) { closeTag.classList.add('hide-close'); }
          else { closeTag.classList.remove('hide-close'); }
        }
        const errorTag = ele.closest('.custom-node-element').querySelector('.unitop-error-icon-div');
        if (errorTag) {
          if (flag) { errorTag.classList.add('hide-close'); }
          else { errorTag.classList.remove('hide-close'); }
        }
        const parentRect = ele.closest('.react-flow__nodes').querySelectorAll('.parent');
        parentRect.forEach((parent) => {
          if (flag) { parent.classList.add('hide-close'); }
          else { parent.classList.remove('hide-close'); }
        });
        Array.from(ele.querySelector(toTag).attributes).forEach(({ name, value }) => {
          imgEle.setAttribute(name, value);
        });
        ele.querySelector(toTag).parentNode.replaceChild(imgEle, ele.querySelector(toTag));
      }
    });
  };
  const onClick = async () => {
    // we calculate a transform for the nodes so that all nodes are visible
    // we then overwrite the transform of the `.react-flow__viewport` element
    // with the style option of the html-to-image library
    // Reduce the white space in the flowsheet diagram in the report by changing spaceAllLTRB 350 to 20
    // const spaceAllLTRB = 350;
    const spaceAllLTRB = 20;
    const nodesBounds = getRectOfNodes(getNodes());
    onTheFlyStyle('input', 'img', true);
    // Element getting for translateX and translateY
    const element = document.querySelector('.react-flow__viewport.react-flow__container');
    const styleEle = element.style.transform;
    // set default flowsheet scale(1) start
    const scale = styleEle.split('scale');
    element.style.transform = `${scale[0]} scale(1)`;
    // set default flowsheet scale(1) End
    // get translateX for Element
    const left = Number(styleEle.split('(')[1].split('px')[0]);
    // get translateY for Element
    const top = Number(styleEle.split('(')[1].split(',')[1].split('px')[0]);
    // get FlowSheet Height StartAdd commentMore actions
    // get the all input exist on flowsheet the get translate value x and y
    // get the y value from element
    // push all y axis value in array. after that get the max value in array
    const translateY_inputBox = [];
    document.querySelectorAll('.react-flow__edgelabel-renderer input').forEach((ele) => {
      const styleEle = ele.style.transform; // get the element style
      let val = styleEle.split('translate'); // split throught translate
      val = val[val.length - 1].split(','); // then split ,
      val = val[val.length - 1]; // get the last value is Y axis
      translateY_inputBox.push(Math.ceil(parseFloat(val, 10))); // push all y axis value in aaray
    });
    const flowsheetHeight = Math.max(...translateY_inputBox); // get the max value inside array

    const translate_unitop = [];
    document.querySelectorAll('.react-flow__node').forEach((ele) => {
      const styleEle = ele.style.transform; // get the element style
      let val = styleEle.split('transform'); // split throught translate
      val = val[val.length - 1].split(','); // then split ,
      val = val[val.length - 1]; // get the last value is Y axis
      translate_unitop.push(Math.ceil(parseFloat(val, 10))); // push all y axis value in aaray
    });
    const flowsheetHeight1 = Math.max(...translate_unitop); // get the max value inside array
    // get FlowSheet Height END
    let flowsheet_height = flowsheetHeight1 > flowsheetHeight ? flowsheetHeight1 + 100 : flowsheetHeight + 100;
    if (flowsheet_height < nodesBounds.height) {
      flowsheet_height = nodesBounds.height + (spaceAllLTRB * 2);
    }
    const imageUrl = await toPng(document.querySelector('.react-flow__pane'), {
      backgroundColor: 'transparent',
      // adding space in width
      width: nodesBounds.width + (spaceAllLTRB * 2),
      // adding space in height
      height: flowsheet_height, // nodesBounds.height + (spaceAllLTRB * 2),
      style: {
        // spaceAllLTRB top and left
        margin: `${-(top) + -(nodesBounds.y - spaceAllLTRB)}px 0 0 ${-(left) - (nodesBounds.x - spaceAllLTRB)}px`,
      },
    }).then((dataUrl) => {
      // const a = document.createElement('a');
      // a.setAttribute('download', 'reactflow.png');
      // a.setAttribute('href', dataUrl);
      // a.click();
      return dataUrl;
    });
    onTheFlyStyle('img', 'input', false);
    // set default flowsheet scale
    element.style.transform = scale.join('scale');
    flowsheetImage(imageUrl);
  };

  return (
    <Panel position="top-left" style={{ display: 'none' }}>
      {/* <Panel position="top-left"> */}
      <button type='button' className="download-btn flowsheet " onClick={onClick}>
        Download Image
      </button>
    </Panel>
  );
}
export default DownloadFlowsheet;